import React from "react";
import "../../styles/ValueSection.css";

const ValueSection = () => {
  return (
    <section className="value-section">
      <div className="value-container">
        <p className="value-tag">
          <div className="highligh">
          BUILT FOR HOSPITALITY FOUNDERS WHO WANT STRUCTURE</div>
        </p>
        

        {/* <h2><b>We Work Best With Leaders Who Value:</b></h2> */}
        {/* <div className="values-grid">
          <div className="value-card"> */}
            <div className="wc-highlight-box">
            We are not for everyone. We are for the operator who knows something has to change.</div>
            {/* <ul className="diagnostic-list arrows">
          <li>Systems over shortcuts</li>
          <li>Visibility over guesswork</li>
          <li>Execution discipline</li>
          <li>Scalable operations</li>
          <li>Long-term profitability</li>
        </ul> */}
        {/* </div>
        </div> */}
        {/* <ul className="value-list"> */}


        {/* <div> < p className="value-high"><b>
          We are not for everyone. We are for the operator who knows something has to change.
        </b></p> */}
        {/* </div> */}
      </div>
    </section>
  );
};

export default ValueSection;
